import { Outlet } from "react-router-dom";
import Footer from "./footer";
import Header from "./header/header";

export default function Layout() {
  return (
    <>
      <Header />
      <div className="min-h-[90vh]">
        <Outlet />
      </div>
      <div className="py-4"></div>
      <Footer />
    </>
  );
}
